<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  all() {
    return axios.get('zonas', AS.getDefaultHeaders());
  },

  fetchZones() {
    return axios.get('zonas', AS.getDefaultHeaders());
  },
  createZone(zoneParams) {
    return axios.post('zonas', { zone: zoneParams }, AS.getDefaultHeaders());
  },
};
</script>
